module.exports = __webpack_public_path__ + "fonts/fontello.0579e2c5.eot";